import React from 'react'

import { ConfirmModal } from '@fourthwall/components'

import type { PaymentMethodItem } from '../../PaymentMethods.types'
import { PaymentMethodsList } from '../PaymentMethodsList/PaymentMethodsList'

type ConfirmRemovePaymentMethodModalProps = {
  paymentMethodProps: PaymentMethodItem
  onConfirm: () => void
  close: () => void
}

export const ConfirmRemovePaymentMethodModal = ({
  paymentMethodProps,
  onConfirm,
  close,
}: ConfirmRemovePaymentMethodModalProps) => (
  <ConfirmModal
    title="Are you sure you want to remove this payment method from this site?"
    text="This action cannot be reversed."
    additionalContent={
      <div style={{ marginTop: 20 }}>
        <PaymentMethodsList paymentMethods={[paymentMethodProps]} />
      </div>
    }
    confirmLabel="Remove"
    confirmAppearance="destructive"
    onConfirm={onConfirm}
    close={close}
  />
)
